import React from 'react';
import { Link } from 'react-router-dom';
import { Button, Popup } from 'semantic-ui-react';
import { isJson } from './Table/utility';

export const LinkButton = ({
  url,
  text,
  icon,
  color,
  basic,
  bgColor,
  size,
}) => {
  const target = isJson(url)
    ? { pathname: url?.pathname, state: url?.state }
    : url;
  // console.log('LinkButton', { target, url, text, icon, color, bgColor, size });

  const style = bgColor ? { backgroundColor: bgColor, color } : null;
  const foreColor = !bgColor ? color : null;
  return (
    <Link to={target}>
      <Button
        primary={!color}
        basic={basic}
        size={size || 'small'}
        compact
        content={text}
        icon={icon}
        color={foreColor}
        style={style}
      />
    </Link>
  );
};

export const TableButton = ({
  onClick,
  text,
  icon,
  color,
  basic,
  bgColor,
  size,
  style,
  helpText,
}) => {
  // const target = isJson(url)
  //   ? { pathname: url?.pathname, state: url?.state }
  //   : url;
  // console.log('LinkButton', { target, url, text, icon, color, bgColor, size });

  // const style = bgColor ? { backgroundColor: bgColor, color } : null;
  // const foreColor = !bgColor ? color : null;
  return helpText ? (
    <Popup
      // header={popupHeader}
      // content={popupText}
      // position={popupPositin}
      content={helpText}
      position="right center"
      size="tiny"
      trigger={
        <Button
          primary={!color}
          onClick={() => {
            onClick();
            return false;
          }}
          basic={basic}
          size={size || 'small'}
          compact
          content={text}
          icon={icon}
          // color={foreColor}
          style={style}
        />
      }
    />
  ) : (
    <Button
      primary={!color}
      onClick={() => {
        onClick();
        return false;
      }}
      basic={basic}
      size={size || 'small'}
      compact
      content={text}
      icon={icon}
      // color={foreColor}
      style={style}
    />
  );
};

export const ModalButton = ({
  onClick,
  text,
  icon,
  color,
  basic,
  bgColor,
  size,
  style,
  helpText,
}) => {
  // const target = isJson(url)
  //   ? { pathname: url?.pathname, state: url?.state }
  //   : url;
  // console.log('LinkButton', { target, url, text, icon, color, bgColor, size });

  // const style = bgColor ? { backgroundColor: bgColor, color } : null;
  // const foreColor = !bgColor ? color : null;
  return (
    <Popup
      // header={popupHeader}
      // content={popupText}
      // position={popupPositin}
      content={helpText}
      position="right center"
      size="tiny"
      trigger={
        <Button
          primary={!color}
          onClick={() => {
            onClick();
            return false;
          }}
          basic={basic}
          size={size || 'small'}
          compact
          content={text}
          icon={icon}
          // color={foreColor}
          style={style}
        />
      }
    />
  );
};
